import { createFromIconfontCN } from '@ant-design/icons-vue'

export default createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4944204_4jw1rs83wc.js',
})
